import type { TBankStatuses } from '@/types/offers';

type TStatusOptionData = {
  text: string;
  value: TBankStatuses;
};

type TStatusOption = {
  text: string;
  value: string;
  label: string;
};

export const statusOptions = (
  [
    { text: 'Профинансировано', value: 'financed' },
    { text: 'Одобрено', value: 'approved' },
    { text: 'Одобрено (Альтернатива)', value: 'accepted_alternative' },
    { text: 'Ожидают ответа от банка', value: 'waiting_bank_response' },
    { text: 'Ожидание финансирования', value: 'waiting_of_financing' },
    { text: 'Отказано', value: 'declined' },
    {
      text: 'Время ожидания ответа банка истекло',
      value: 'bank_response_timeout'
    },
    { text: 'Черновик', value: 'draft' }
  ] satisfies TStatusOptionData[]
).map((item): TStatusOption => ({ ...item, label: item.text }));
